"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js");
require("regenerator-runtime/runtime");
const React = __importStar(require("react"));
const ReactDOM = __importStar(require("react-dom"));
require("../assets/styles/index.scss");
const react_redux_1 = require("react-redux");
const styles_1 = require("@material-ui/core/styles");
const store_1 = __importDefault(require("../redux/store"));
const app_1 = __importDefault(require("./chat/app"));
const app_2 = __importDefault(require("./profile/app"));
const app_3 = __importDefault(require("./admin/app"));
const app_4 = __importDefault(require("./directories/app"));
const app_5 = __importDefault(require("./directories/services/app"));
const app_6 = __importDefault(require("./directories/experts/app"));
const app_7 = __importDefault(require("./userHistory/app"));
const app_8 = __importDefault(require("./whatsNew/app"));
const app_9 = __importDefault(require("./newsFeed/app"));
const app_10 = __importDefault(require("./lawFirmProfile/app"));
const createProfile_1 = __importDefault(require("./lawFirmProfile/createProfile/createProfile"));
const app_11 = __importDefault(require("./notificationCenter/app"));
const app_12 = __importDefault(require("./subscription/app"));
const overridesTheme_1 = __importStar(require("./overridesTheme"));
const preloader_1 = __importDefault(require("../shared/components/preloader/preloader"));
const staticDataSlice_1 = require("../redux/slices/staticDataSlice");
const theme = styles_1.createMuiTheme(overridesTheme_1.default, overridesTheme_1.Palette);
class Root {
    constructor(props) {
        const { container, component, options } = props;
        this.container = container;
        this.components = {
            chat: app_1.default,
            profile: app_2.default,
            admin: app_3.default,
            directory: app_4.default,
            experts: app_6.default,
            services: app_5.default,
            userHistory: app_7.default,
            whatsNew: app_8.default,
            newsFeed: app_9.default,
            lawFirmProfile: app_10.default,
            lawFirmCreate: createProfile_1.default,
            notificationCenter: app_11.default,
            subscription: app_12.default
        };
        this._init(this.components[component], options);
    }
    renderer(htmlContent) {
        return ReactDOM.render(React.createElement(styles_1.ThemeProvider, { theme: theme },
            React.createElement(react_redux_1.Provider, { store: store_1.default, context: react_redux_1.ReactReduxContext },
                htmlContent,
                React.createElement(preloader_1.default, null))), document.getElementById(this.container));
    }
    _init(Component, options = {}) {
        try {
            return this.renderer(React.createElement(Component, { options: options }));
        }
        catch (e) {
            return this.renderer(React.createElement("div", null,
                React.createElement("b", null, "Widget Can't load please contact with support")));
        }
    }
    destroy(container) {
        try {
            store_1.default.dispatch(staticDataSlice_1.resetStore());
            ReactDOM.unmountComponentAtNode(container);
        }
        catch (e) {
            console.log('destroy exception', e);
        }
    }
}
exports.default = Root;
